<template>
    <public-layout>

        <div class="container py-5">

            <div class="head text-center mb-4">
                <template v-if="type === 'activity'" >
                    <h1>Design for Change - Activities</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus praesentium quaerat quia soluta tenetur? Eos est explicabo impedit, ipsum iusto necessitatibus reiciendis tempore? Aspernatur aut ea enim, ex inventore ut.</p>
                </template>
                <template v-if="type === 'resource'" >
                    <h1>Design for Change - Resources</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus praesentium quaerat quia soluta tenetur? Eos est explicabo impedit, ipsum iusto necessitatibus reiciendis tempore? Aspernatur aut ea enim, ex inventore ut.</p>
                </template>
            </div>

            <div class="text-center mb-4">
                <div class="btn-group border rounded">
                    <inertia-link :href="route(`public.${type}.index`)"
                                  class="btn"
                                  :class="{'btn-primary': !stage}">All</inertia-link>
                    <inertia-link :href="route(`public.${type}.index`, {filters: {stage: 'feel'}})"
                                  :class="{'btn-primary': stage === 'feel'}"
                                  class="btn">Feel</inertia-link>
                    <inertia-link :href="route(`public.${type}.index`, {filters: {stage: 'imagine'}})"
                                  :class="{'btn-primary': stage === 'imagine'}"
                                  class="btn">Imagine</inertia-link>
                    <inertia-link :href="route(`public.${type}.index`, {filters: {stage: 'do'}})"
                                  :class="{'btn-primary': stage === 'do'}"
                                  class="btn">Do</inertia-link>
                    <inertia-link :href="route(`public.${type}.index`, {filters: {stage: 'share'}})"
                                  :class="{'btn-primary': stage === 'share'}"
                                  class="btn">Share</inertia-link>
                </div>
            </div>

            <div v-if="items.length > 0" class="row align-items-stretch justify-content-center">
                <div class="col-lg-4 col-md-6 d-flex align-items-stretch"
                     v-for="item in items"
                     :key="item.id">
                    <canvas-element-card class="w-100 mb-3 item"
                                         :element="item" />
                </div>
            </div>
            <div v-else>
                <div class="text-center text-danger">
                    Sorry, we cannot find any {{ type }}.
                </div>
            </div>
        </div>

        <div class="text-center pb-5 mb-5">
            <pagination :links="canvasElements.links"/>
        </div>

    </public-layout>
</template>

<script>
import PublicLayout from "@/Layouts/PublicLayout";
import CanvasElementCard from "@/Components/Public/CanvasElement/CanvasElementCard";
import Pagination from "@/Components/Common/Pagination";
import Modal from "@/Components/Common/Modal";
import Button from "@/Jetstream/Button";
import utils from "@/mixins/utils";
import Input from "@/Jetstream/Input";

export default {
    name: "Index",
    components: {CanvasElementCard, Input, Button, Modal, Pagination, PublicLayout},
    mixins: [utils],
    props: ['canvasElements', 'type', 'stage'],

    data(){
        return {

        }
    },

    computed: {

        items(){
            return this.canvasElements.data.filter(e => !(e.type === 'resource' && e.data?.type === 'podcast'));
        }
    },

}
</script>

<style lang="scss" scoped>
.head{
    max-width: 600px;
    margin: auto;
}

.item{
    cursor: pointer;
    transition: background-color .3s;
    user-select: none;

    &:hover{
        background: darken($light, 2%);
    }
}
</style>
